import React from 'react';
import { get } from 'lodash';
import { getStore } from 'configureStore';
import {
  COMMON_ERROR_BODY,
  COMMON_ERROR_TITLE,
  INTERNAL_SERVER_ERROR,
  MESSAGE_ERROR,
} from 'constants/responseErrors';
import { showToast } from 'modules/Notifications/redux/actions';
import { ERROR } from 'modules/Toasts/constants/toastTypes';

/**
 * Show notification if internal server error found
 * @returns {function(error: Error): Promise<Error>}
 */
const errorHandlerInterceptor = () => (error) => {
  const responseStatus = get(error, 'response.status');
  const responseData = get(error, 'response.data');
  const errorType = get(responseData, 'errorType');
  const { dispatch } = getStore();

  if (responseStatus === INTERNAL_SERVER_ERROR) {
    dispatch(
      showToast({
        type: ERROR,
        notification: {
          message: COMMON_ERROR_TITLE,
          details: COMMON_ERROR_BODY,
          options: {
            toastId: INTERNAL_SERVER_ERROR,
          },
        },
      }),
    );
  }

  if (errorType === MESSAGE_ERROR) {
    dispatch(
      showToast({
        type: ERROR,
        notification: {
          message: get(responseData, 'message', null),
          details: <pre>{get(responseData, 'detailedMessage', null)}</pre>,
          options: {
            toastId: MESSAGE_ERROR,
          },
        },
      }),
    );
  }

  return Promise.reject(error);
};

export default errorHandlerInterceptor;
